<a (click)="select()" class="chips-option">
  <span>{{getDisplayValue(value)}}</span>
</a>
